module.exports = __webpack_public_path__ + "img/pijlen-blauw-lijn.05606c763d0dc03f82502f78b9cfe141.svg";